import styled, { css } from "styled-components";

export const InstancesPanel = styled.div<{ $open: boolean }>`
  overflow: hidden;
  border-top: 1px dashed #e5e7eb;
  padding-top: ${({ $open }) => ($open ? "10px" : "0px")};
  max-height: ${({ $open }) => ($open ? "500px" : "0px")};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition: max-height 240ms ease, opacity 160ms ease, padding-top 160ms ease;

  display: flex;
  flex-direction: column;
  gap: 12px;

  /* ✅ 내부 스크롤 영역 */
  ${({ $open }) =>
    $open &&
    css`
      overflow-x: auto;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #cbd5e1 #f8fafc;

      /* 스크롤바 꾸미기 (크롬, 엣지 등) */
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #cbd5e1;
        border-radius: 999px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: #94a3b8;
      }
      &::-webkit-scrollbar-track {
        background-color: #f8fafc;
      }
    `};
`;
